import suspiciousWords from './suspicious-word-dict.json'

const suspiciousWordsRE = new RegExp('[^!@#$%^&*]*(\\b' + suspiciousWords.join('\\b|\\b') + '\\b)[^!@#$%^&*]*', 'i')
export const mutedUntilTextForSingleSessionMutes = 'the next game'

export function hasSuspiciousWords(text: string): boolean {
    return suspiciousWordsRE.test(text)
}
